/**
 * Formats provider pronoun sets for display (e.g. ["she/her", "they/them"] → "She/Her/They/Them").
 * Capitalizes each set and joins multiple sets with "/" to match provider profile formatting.
 */
export function formatProviderPronouns(
  pronouns: string[] | null | undefined
): string {
  if (!pronouns?.length) {
    return ''
  }

  return pronouns
    .map((pronoun) =>
      pronoun
        .split('/')
        .map((p) => p.charAt(0).toUpperCase() + p.slice(1))
        .join('/')
    )
    .join('/')
}
